import { useEffect, useState } from 'react';
import { isFeatureEnabled, waitTillAvailable } from '@vp/ab-reader';

const DESIGNER_REVIEW_GATE = 'design_services_designer_review';

export function useDesignerReviewGate(enabled = true): boolean {
    const [flagEnabled, setFlagEnabled] = useState(false);
    useEffect(() => {
        if (!enabled) return;
        waitTillAvailable(1000).then((available) => {
            setFlagEnabled(available && isFeatureEnabled(DESIGNER_REVIEW_GATE));
        });
    }, [enabled]);
    return flagEnabled;
}
